import type { FaireProductEntity } from "../../entity_types/product";

export const p_ss32by86xz: FaireProductEntity = {
  token: "p_ss32by86xz",
  type: "product",
  name: "Rhinestone Pave Baseball Stud Earrings",
  brandToken: "b_c3xmn96nkh",
  brandName: "Sensibling Corp.",
  imageUrl:
    "https://cdn.faire.com/fastly/41eda210e06c763df75367c14291ce59a63850a4b79f12157053eb720f31f11b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/49362f3d7dac0c63f288bb30213769ac2d3c2597fd05c070ec828d3c5b117009.jpeg",
  ],
  priceDollars: 5.72,
  description:
    'Size : 0.5" X 0.5"\r\nPost Back\r\nSparkling baseball stud earrings featuring a pavé crystal surface and classic stitch detail silhouette. Designed for game day outfits, sports fans, and everyday casual styling. A fun accessory for teams, events, and gifting with eye-catching shine and playful athletic flair.\nLead and Nickel Compliant\n',
  tags: [],
  msrpDollars: 11.45,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:31.429Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
